import admin from "firebase-admin";
import { j as json } from "../../../../../chunks/index2.js";
const GET = async ({ params, fetch }) => {
  const id = params.id;
  if (id) {
    const docRef = admin.firestore().collection("users").doc(id);
    const user = await docRef.get();
    if (user.exists) {
      return json(user.data());
    }
    return fetch(`/api/users?email=${id}@glimmr.com`);
  }
  return json({ error: "No query provided" }, { status: 400 });
};
export {
  GET
};
